
import Fortified from "../../assets/images/events/optizimized/fortified2.webp"
import ZelleQR from "../../assets/images/events/qr/zelleqr.png";
import CashAppQR from "../../assets/images/events/qr/cashapp.png";

export const eventConfig = {
  id: "fortified-Relationship_01",

  title: "Fortified Relationship Retreat 2027",
  description:
    "Join Pure Business Solutions for our upcoming event. Fortifying relationships in God's way",

  date: "February 12-14, 2027",
  time: "To be determined",
  location: "Double Tree by Hilton",

  flyer: `${Fortified}`,

  registrationTypes: {
    single: {
      label: "Single",
      description: "Individual registration",
      price: 100,
      attendees: 1,
    },
    married: {
      label: "Married Couple",
      description: "Registration for two spouses",
      price: 190,
      attendees: 2,
    },
  },

  paymentMethods: {
    cashapp: {
      label: "Cash App",
      recipient: "$purepartners4life",
      url: "https://cash.app/$purepartners4life",
      qrImage: CashAppQR,
    },
    zelle: {
      label: "Zelle",
      recipient: "931-220-2796",
      url: null,
      qrImage: ZelleQR,
    },
  },

  registrationEmail: "mauriceandkimjohnson42@gmail.com",
};
